export default __webpack_public_path__ + "static/media/IMG_20181227_084925.ec0ae3ec.jpg";